// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"e31d17aa","container":"b32eef33","left":"a852c804","right":"bf54a794"};